
import React from "react";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { PropTypes } from "prop-types";

import { useI18n } from "../../../i18n/useI18n";

const [HbrButton, HbrModal] =
    reactWrapper(["hbr-button", "hbr-modal"]);

const HelpModal = ({ openHelpModal, about }) => {
    const { tGenerics } = useI18n('generics');

    const closeModal = () => {
        openHelpModal(false);
    }

    return (
        <HbrModal label="Cisco Catalyst SD-WAN" open={true}>
            <div className="hbr-type-body3">{tGenerics('helpModalPlatform')}</div>
            <div className="subtitle">{about.version}</div>
            <br />
            <div className="hbr-type-body3">{tGenerics('helpModalVersion')}</div>
            <div className="subtitle">{about.applicationVersion}</div>
            <br />
            <div className="hbr-type-body3">{tGenerics('helpModalServer')}</div>
            <div className="subtitle">{about.applicationServer}</div>
            <br />
            <div className="hbr-type-body3">{tGenerics('helpModalTime')}</div>
            <div className="subtitle">{about.time}</div>
            <br />
            <div className="hbr-type-body3">{tGenerics('helpModalZone')}</div>
            <div className="subtitle">{about.timeZone}</div>
            <br />
            <div className="hbr-type-body3">{about.copyright}</div>

            <div
                slot="footer"
                className="hbr-css__layout-row-md hbr-css__layout-justify-end"
            >
                <HbrButton variant="text" onClick={closeModal}>
                    {tGenerics('helpModalClose')}
                </HbrButton>
            </div>
        </HbrModal>
    )


}

HelpModal.propTypes = {
    openHelpModal: PropTypes.func,
    about: PropTypes.object
}

export default HelpModal;